<!--
 * @Author: zhonghao
 * @Date: 2023-07-12 10:24:29
-->
<template>
  <div class="personal">
    <headerComponent></headerComponent>
    <div class="main">
      <div class="per-top">
        <img :src="userInfo.headimgurl" class="img-top" alt="">
        <div class="top-con">
          <div class="txt-name">{{ userInfo.nickname }}</div>
          <div class="txt-tag" v-if="userInfo && userInfo.join_level_text">{{ userInfo.join_level_text }}（{{userInfo.mobile}}）</div>
          <div class="txt-tag" v-else>（{{userInfo.mobile}}）</div>
          <!-- <div class="txt-tag" v-if="userInfo.my_vip_label">普通会员</div>
          <div class="txt-tag status" v-else>
            <img src="@/assets/images_member/per1 (11).png" class="tag-icon" alt="">
            {{ userInfo.my_vip_label[0] }}
          </div> -->
        </div>
      </div>
      <div class="flex-nav">
        <div class="nav-item" @click="handleJump('BALANCE')">
          <div class="txt-num">{{ Number(userInfo.money) + Number(userInfo.rec_money) }}</div>
          <div class="txt-tip">
            账户余额
            <img src="@/assets/images_member/per1 (53).png" class="icon-arrow" alt="">
          </div>
        </div>
        <div class="nav-item" @click="handleJump('CUSTOM')">
          <div class="txt-num">{{ cusotmObject.all }}</div>
          <div class="txt-tip">
            我的客户
            <img src="@/assets/images_member/per1 (53).png" class="icon-arrow" alt="">
          </div>
        </div>
        <div class="nav-item" @click="handleJump('PAGECARD')">
          <div class="txt-num">{{ cusotmObject.agent }}</div>
          <div class="txt-tip">
            开通会员
            <img src="@/assets/images_member/per1 (53).png" class="icon-arrow" alt="">
          </div>
        </div>
      </div>
      <div class="div-daili">
        <img src="@/assets/images_member/20230719/Group 842@2x.png" class="daili-bg" alt="">
        <div class="daili-top">
          <img src="@/assets/images_member/per1 (20).png" class="icon-top" alt="">
          <div class="daili-txt">幸福公社AI会员</div>
        </div>
        <div class="daili-con">
          <div class="cons-left">
            <div class="cons-left-txt">
              尊享权益 全面升级
            </div>
            <div class="cons-tip">SVIP、联合会员、生态会员</div>
          </div>
          <div class="cons-btn" @click="handleJump('OPENMENBER')">{{ userInfo.wine_level > 0 ? '查看权益' : '我要开通' }}</div>
        </div>
      </div>
      <div class="div-flex">
        <div class="div-flex-item" @click="handlePath('/wine/wineHome')">
          <img src="@/assets/images_member/per1 (18).png" class="flex-img" alt="">
          <div class="item-con">
            <div class="con-txt1">喜酱酒中心</div>
            <div class="con-txt2">喜酱酒管理</div>
          </div>
        </div>
        <div class="div-flex-item" @click="handlePath('/xfgpt/')">
          <img src="@/assets/images_member/per1 (19).png" class="flex-img" alt="">
          <div class="item-con">
            <div class="con-txt1">我的课程</div>
            <div class="con-txt2">AI课程-小程序</div>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="block-title">服务工具</div>
        <div class="list">
          <div class="item" @click="handlePath('/xfgpt/')">
            <img src="@/assets/images_member/per1 (7).png" class="item-icon" alt="">
            <div class="item-txt">AI小助手</div>
          </div>
          <div class="item" @click="handleJump('SHAREPOSETER')">
            <img src="@/assets/images_member/per1 (9).png" class="item-icon" alt="">
            <img src="@/assets/images_member/per1 (12).png" class="item-tip" alt="">
            <div class="item-txt">邀请好友</div>
          </div>
          <div class="item" @click="handleJump('BALANCE')">
            <img src="@/assets/images_member/per1 (6).png" class="item-icon" alt="">
            <div class="item-txt">账户余额</div>
          </div>
          <div class="item" @click="handleJump('PAGECARD')">
            <img src="@/assets/images_member/20230719/icon-card.png" class="item-icon" alt="">
            <div class="item-txt">我的卡包</div>
          </div>
          <div class="item" @click="handleJump('PAGEHOME')">
            <img src="@/assets/images_member/20230719/icon-per.png" class="item-icon" alt="">
            <div class="item-tip">最新</div>
            <div class="item-txt">会员中心</div>
          </div>
          <div class="item" @click="handleJump('GIFTMENBER')" v-if="userInfo.give_svip > 0">
            <img src="@/assets/images_member/20230719/Frame@2x.png" class="item-icon" alt="">
            <div class="item-txt">赠送会员</div>
          </div>
          <div class="item" @click="handlePath('/wine/address')">
            <img src="@/assets/images_member/per1 (4).png" class="item-icon" alt="">
            <div class="item-txt">收货地址</div>
          </div>
          <div class="item" @click="handleJump('SINGLEPAGE')">
            <img src="@/assets/images_member/per1 (5).png" class="item-icon" alt="">
            <div class="item-txt">关于我们</div>
          </div>
          <!-- <div class="item" @click="handleJump('setpassword')">
            <img src="@/assets/images_member/20231018/img(10).png" class="item-icon" alt="">
            <div class="item-txt">设置密码</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headerComponent from '@/components/HeaderComponent.vue'
import { handleGoToPath } from '@/utils/comm'
import { cusotm, setPassword } from '@/api/person'
import store from '@/store'
import { Toast } from 'vant'
export default {
  name: 'personal',
  components: {
    headerComponent
  },
  data () {
    return {
      cusotmObject: {},
      // userInfo: {}
    }
  },
  computed: {
    userInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
    }
  },
  mounted () {
    store.dispatch('GetUsers').then(res => {
    })
    this.handleFunction()
  },
  methods: {
    handlePath (url) {
      handleGoToPath(url)
    },
    handleFunction () {
      cusotm().then(res => {
        this.cusotmObject = res.data
      })
    },
    handleJump (type) {
      let url = ''
      let typeRole = ''

      switch (type) {
        case 'HAPPINESS':
          url = '/happiness'
          break
        case 'SHAREPOSETER':
          url = '/sharePoster'
          break
        case 'CUSTOM':
          url = '/custom'
          break
        case 'ADDRESSSLIST':
          url = '/address'
          break
        case 'GIFTMENBER':
          url = '/giftMenber'
          break
        case 'PAGEHOME':
          url = '/pageHome'
          break
        case 'PAGECARD':
          url = '/pageCard'
          break
        case 'AGENCY':
          url = '/agencyCenter'
          typeRole = this.userInfo.wine_level
          break
        case 'BALANCE':
          url = '/balance'
          break
        case 'OPENMENBER':
          if (this.userInfo.wine_level > 0) {
            url = `/vipTypeInfo?level_type=svip_level&level=${this.userInfo.svip_level}`
          } else {
            url = '/openMenber'
          }
          break
        case 'SINGLEPAGE':
          url = '/singlePage?id=4'
          break
        case 'setpassword':
          setPassword().then(res => {
            if (res.has_password) {
              this.$dialog.alert({
                title: '温馨提示',
                message: '您的登录密码已设置，如需修改请前往“DoDo星球”App'
              })
            } else {
              this.$router.push({
                path: '/setPassword'
              })
            }
          })
          return

        default:
          break
      }
      let pathParams = {
        path: url,
      }
      if (typeRole) {
        pathParams.query = { typeRole }
      }
      this.$router.push(pathParams)
    },
    handleToast () {
      Toast('功能正在开发中...')
    }
  }
}
</script>

<style lang="less" scoped>
.personal {
  background-color: #1E2020;
  min-height: 100vh;
  width: 100vw;

  .main {
    padding: 0 14px;
    box-sizing: border-box;
  }

  .per-top {
    padding: 24px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .img-top {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 10px;
    }

    .top-con {
      display: flex;
      flex-direction: column;

      .txt-name {
        font-size: 20px;
        color: #F0E1C0;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 12px;
      }

      .txt-tag {
        height: 20px;
        border-radius: 100px;
        text-align: center;
        line-height: 20px;
        box-sizing: border-box;
        font-size: 12px;
        color: #999999;

        &.status {
          display: flex;
          align-items: center;
          padding: 0 13px;
          box-sizing: border-box;
          color: #E0C894;
          border-color: #E0C894;
          width: auto;

          .tag-icon {
            width: 14px;
            height: 14px;
            margin-right: 4px;
          }
        }
      }
    }
  }

  .flex-nav {
    display: flex;
    justify-content: space-between;

    .nav-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .txt-num {
        font-size: 18px;
        color: #F0E1C0;
        font-weight: 600;
      }

      .txt-tip {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #999999;
      }

      .icon-arrow {
        width: 6px;
        height: 12px;
        margin-left: 5px;
      }
    }
  }

  .div-daili {
    position: relative;
    margin-top: 24px;

    .daili-bg {
      height: 114px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    .daili-top {
      display: flex;
      align-items: center;
      height: 46px;
      padding: 12px 14px;
      box-sizing: border-box;
      position: relative;

      .icon-top {
        width: 22px;
        height: 22px;
        margin-right: 7px;
      }

      .daili-txt {
        font-size: 18px;
        color: #504632;
        font-weight: 600;
        flex: 1;
      }

      .daili-status {
        font-size: 14px;
        color: #826C49;
        font-weight: 500;
      }
    }

    .daili-con {
      height: 68px;
      display: flex;
      align-items: center;
      padding: 16px 14px;
      box-sizing: border-box;
      position: relative;
      justify-content: space-between;

      .cons-left {
        display: flex;
        flex-direction: column;

        .cons-left-txt {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #826C49;
          font-weight: bold;
        }

        .cons-left-icon {
          width: 6px;
          height: 12px;
          margin-left: 7px;
        }
      }

      .cons-tip {
        font-size: 12px;
        color: #826C49;
        line-height: 12px;
        margin-top: 10px;
      }

      .cons-btn {
        width: 88px;
        height: 34px;
        background-color: #2F3131;
        border-radius: 100px;
        text-align: center;
        line-height: 34px;
        font-weight: bold;
        color: #F0E1C0;
        font-size: 14px;
      }
    }
  }

  .div-flex {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;

    .div-flex-item {
      background-color: #2F3131;
      border-radius: 10px;
      width: 167px;
      height: 63px;
      display: flex;
      align-items: center;
      padding: 12px 14px;
      box-sizing: border-box;

      .flex-img {
        width: 27px;
        height: 27px;
        margin-right: 8px;
      }

      .item-con {
        display: flex;
        flex-direction: column;

        .con-txt1 {
          font-size: 16px;
          color: #FFFFFF;
          font-weight: 500;
          margin-bottom: 10px;
          line-height: 16px;
          position: relative;

          &.cur::after {
            position: absolute;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            right: 12px;
            top: 0px;
            content: "";
            background-color: #FF4E4E;
          }
        }

        .con-txt2 {
          font-size: 12px;
          color: #999999;
          line-height: 12px;
        }
      }
    }
  }

  .block {
    background-color: #292B2A;
    border-radius: 10px;
    padding: 20px 14px;
    box-sizing: border-box;
    margin-top: 14px;

    .block-title {
      font-size: 16px;
      color: #FFFFFF;
      font-weight: 500;
    }

    .list {
      display: flex;
      flex-wrap: wrap;

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        width: 25%;
        margin-top: 30px;

        .item-tip {
          width: 32px;
          height: 16px;
          position: absolute;
          left: 0;
          top: 0;
          left: 48px;
          top: -5px;
          line-height: 16px;
          text-align: center;
          color: #fff;
          font-size: 11px;
          border-radius: 100px 100px 100px 0;
          background: linear-gradient(270deg, #FF621F 0%, #FAA72A 100%);
        }

        .item-icon {
          width: 20px;
          height: 20px;
          margin-bottom: 10px;
        }

        .item-txt {
          font-size: 12px;
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/index.vue